import { Box, Grid, TableContainer } from '@mui/material';
import { mainTableColumnTitles } from './consts';
import EmptyTableSection from '../../../../components/DataTable/EmptyTableSection';
import useSubstancesModule from './hooks/useSubstancesModule';
import { TEST_IDS } from './testIds';
import DataTable from '../../../../components/DataTable/DataTable';
import { useAppSelector } from '../../../../hooks/reduxHooks';
import TableActionButton from '../../../../components/DataTable/TableActionButton';
import EditIcon from '@mui/icons-material/Edit';
import EyeIcon from '@mui/icons-material/Visibility';
import DrawerManager from './components/drawers';
import InformationStateBadge from '../../components/InformationStateBadge';
import { HandleTabChange, TAB_INDEX } from '../../pages';
import { CarcinogenicModuleFooter } from '../../components/CarcinogenicModuleFooter';
import { isSubstanceDataComplete } from './helpers';
import { useNavigate } from 'react-router-dom';
interface SubstancesAndPreventiveMeasuresTabContenProps {
    handleTabChange: HandleTabChange;
    showCancelCarcinogenicReportAlert: any;
    allowNext: boolean;
    onlyVisual: boolean;
}

const SubstancesAndPreventiveMeasuresTabContent = ({
    handleTabChange,
    showCancelCarcinogenicReportAlert,
    allowNext,
    onlyVisual
}: SubstancesAndPreventiveMeasuresTabContenProps) => {
    const navigate = useNavigate()
    const carcinogenicReport = useAppSelector(
        (state) => state.carcinogenicReport.carcinogenicReport
    );
    const {
        substances,
        isFetchingSubstances,
        selectedItemFromAction,
        selected,
        substancesFilters,
        substancesTableMenu,
        open,
        setOpen,
        handleRowClick,
        handleClickAction,
        handleEditClick,
        translate
    } = useSubstancesModule();

    const handleFooterCancelClick = () => {
        if (onlyVisual) {
            handleTabChange(TAB_INDEX.ESTABLISHMENT_DATA);
            return;
        };
        showCancelCarcinogenicReportAlert({ confirmAction: () => navigate(-1) });
    };

    const { filters, setFilters } = substancesFilters;
    const { menuOpen } = substancesTableMenu;

    return (
        <>
            <Box
                component="div"
                justifyContent="center"
                bgcolor={'#ffffff'}
                borderRadius={'0px 0px 6px 6px'}
                p={3}
            >
                <Grid item xs={12}>
                    {substances?.data?.length === 0 ? (
                        <EmptyTableSection title={translate('table.noData.title')} />
                    ) : (
                        <TableContainer>
                            <DataTable
                                testID={TEST_IDS.table.id}
                                columnTitles={mainTableColumnTitles(translate)}
                                columnWidths={[]}
                                onSelectRow={handleRowClick}
                                selected={selected}
                                selectedItemFromAction={selectedItemFromAction}
                                menuOpen={menuOpen}
                                items={{ data: { data: carcinogenicReport?.sustancias } }}
                                loading={false}
                                filters={filters}
                                setFilters={setFilters}
                                isFetching={false}
                                headers={[
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) => `${item?.codigo}`
                                    },
                                    {
                                        type: 'data',
                                        maxWidth: '200px',
                                        upperLabel: (item: any) => `${item?.descripcion}`
                                    },
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) => `${item?.nombrePuesto}`
                                    },
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) => `${item?.nombreSector}`
                                    },
                                    {
                                        type: 'data',
                                        upperLabel: (item: any) => (
                                            <InformationStateBadge
                                                state={
                                                    isSubstanceDataComplete(item)
                                                        ? 'complete'
                                                        : 'incomplete'
                                                }
                                            />
                                        )
                                    },
                                    {
                                        type: 'data',
                                        lowerLabel: (item: any) => (
                                            <Box display={'flex'} gap={1.5}>
                                                <TableActionButton
                                                    disabled={false}
                                                    onClick={() => handleEditClick(item)}
                                                    IconComponent={!onlyVisual ? EditIcon : EyeIcon}
                                                />
                                            </Box>
                                        )
                                    }
                                ]}
                            />
                        </TableContainer>
                    )}
                    <DrawerManager
                        open={open}
                        setOpen={setOpen}
                        selectedSubstance={selected}
                        translate={translate}
                        onlyVisual={onlyVisual}
                    />
                </Grid>
            </Box>
            <CarcinogenicModuleFooter
                disableNextButton={!allowNext}
                handleCancelClick={handleFooterCancelClick}
                handleSubmitClick={(e: any) =>
                    allowNext && handleTabChange(e, TAB_INDEX.PROVIDERS_AND_BUYERS)
                }
                onlyVisual={onlyVisual}
            />
        </>
    );
};

export default SubstancesAndPreventiveMeasuresTabContent;
